import ViewContactLogCell from './ViewContactLogCell';

export default ViewContactLogCell;
